import { Injectable } from '@angular/core';
import { Router, Params, ActivatedRoute, ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Client } from './client.model';
import { ClientService } from './client.service';


@Injectable()
export class ClientGuard implements Resolve<Client> {

  constructor(public router: Router, private clientService: ClientService) { }

  private clientId: string;

  resolve(route: ActivatedRouteSnapshot) {
    this.clientId = route.params['clientId'];
    return this.clientService.getClientById(this.clientId);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/client/client.guard.ts